import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import LandingPage from "@/pages/LandingPage";
import AdminPage from "@/pages/AdminPage";
import CasePage from "@/pages/CasePage";
import ShowcasePage from "@/pages/ShowcasePage";
import GatedCasePage from "@/pages/GatedCasePage";

function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<GatedCasePage />} />
        <Route path="/admin" element={<AdminPage />} />
        <Route path="/cases/:slug" element={<CasePage />} />
        <Route path="/showcase/:slug" element={<ShowcasePage />} />
        <Route path="/full" element={<LandingPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
